import React, {Component, PropTypes} from 'react'
import { Time, isSameDay } from './time'
import {MarkdownText} from './markdown_text'
// TODO import modal for editing

export class Message extends Component {
  static propTypes = {
    message: PropTypes.object.isRequired,
    messageOwner: PropTypes.object,
    nextMessage: PropTypes.object,
    previousMessage: PropTypes.object,
    userId: PropTypes.string,
    deleteMessage: PropTypes.func,
    saveMessage: PropTypes.func
  }

  static defaultProps = {
    nextMessage: {},
    previousMessage: {}
  }

  render () {
    const { userId, message, messageOwner, nextMessage, previousMessage } = this.props

    let className = 'message list-item m--border'
    if (message.owner === nextMessage.owner &&
        isSameDay(message.created, nextMessage.created)) {
      className += ' m--has-next'
    }
    if (message.owner === previousMessage.owner &&
        isSameDay(message.created, previousMessage.created)) {
      className += ' m--has-previous'
    }
    if (message.owner === userId) className += ' message--mine'

    return (
      <div className={className}>
        <div
          className="list-item__avatar"
          style={{backgroundImage: messageOwner.avatarUrl && 'url('+messageOwner.avatarUrl+')'}}
        />
        <div className="list-item__content">
          <div className="list-item__name">
            {messageOwner.name}
          </div>
          <MarkdownText className="message__message" text={message.body} />
        </div>
        <div className="list-item__extra">
          <Time time={message.created} format='time'/>
          <div className="message__options">
            <span className="icon-pencil" onClick={() => this.setState({ showEditModal: true })}/>
            <span className="icon-trash" onClick={this.props.deleteMessage}/>
          </div>
        </div>
      </div>
    )
  }
}
